import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen } from 'lucide-react';
export function OfferSection() {
  return <section className="py-8 px-4 sm:px-6 lg:px-8 bg-zinc-900/30" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <div className="text-center mb-6" data-id="element-63">
          <h2 className="text-2xl md:text-3xl font-serif text-white mb-1 leading-[1.1]" data-id="element-64">
            Lo que recibes
          </h2>
          <p className="text-zinc-400 text-sm leading-[1.2]" data-id="element-65">
            Todo lo que necesitas para romper el hielo hoy mismo.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} whileHover={{
        y: -5
      }} className="bg-[#0a0a0a] border border-zinc-800 p-5 rounded-xl shadow-xl" data-id="element-66">
          <div className="w-10 h-10 bg-zinc-900 rounded-lg flex items-center justify-center mb-3" data-id="element-67">
            <BookOpen className="w-5 h-5 text-[#d4a574]" data-id="element-68" />
          </div>
          <h3 className="text-xl font-serif text-white mb-1 leading-[1.1]" data-id="element-69">
            La Guía Completa (PDF)
          </h3>
          <p className="text-zinc-500 mb-3 text-xs leading-[1.2]" data-id="element-70">
            Lectura rápida de 20 minutos
          </p>

          <ul className="space-y-2" data-id="element-71">
            {['Cómo identificar si tu relación está en Hielo, Neutro o Cercanía', 'Qué mensaje usar según el clima (para no sabotearte)', 'Los 5 MDE listos para copiar/pegar', 'Plan simple de 7 días para sostener la reconexión', 'Biblioteca extra: post-pelea, estrés, rechazo'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-72">
                <Check className="w-4 h-4 text-[#d4a574] flex-shrink-0 mt-0.5" data-id="element-73" />
                <span className="text-zinc-300 text-xs leading-[1.2]" data-id="element-74">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}